import React, { createContext, useState, useContext, useEffect } from 'react';
import { businessAPI } from '../services/api';
import { useAuth } from './AuthContext';

const BusinessContext = createContext(null);

export const useBusiness = () => {
  const context = useContext(BusinessContext);
  if (!context) {
    throw new Error('useBusiness must be used within a BusinessProvider');
  }
  return context;
};

export const BusinessProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [business, setBusiness] = useState(null);
  const [loading, setLoading] = useState(true);

  // This provider wraps the whole app, including the login page, but
  // GET /api/business is jwt_required. Firing it while logged out earns a 401
  // for no benefit, so wait until there is a session. The businessName fallback
  // below covers any consumer that renders before then.
  useEffect(() => {
    if (isAuthenticated) {
      loadBusiness();
    } else {
      setBusiness(null);
      setLoading(false);
    }
  }, [isAuthenticated]);

  const loadBusiness = async () => {
    try {
      const response = await businessAPI.get();
      setBusiness(response.data);
    } catch (error) {
      console.error('Error loading business:', error);
      // Set default business name if API fails
      setBusiness({ business_name: 'KT Mountain Ranch Quarter Horses' });
    } finally {
      setLoading(false);
    }
  };

  const updateBusiness = (businessData) => {
    setBusiness(businessData);
  };

  const value = {
    business,
    loading,
    loadBusiness,
    updateBusiness,
    businessName: business?.business_name || 'KT Mountain Ranch Quarter Horses',
  };

  return <BusinessContext.Provider value={value}>{children}</BusinessContext.Provider>;
};

